"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.verifyMessage = verifyMessage;
exports.verifyTypedData = verifyTypedData;
exports.Wallet = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _address = require("@ethersproject/address");

var _abstractProvider = require("@ethersproject/abstract-provider");

var _abstractSigner = require("@ethersproject/abstract-signer");

var _bytes = require("@ethersproject/bytes");

var _hash = require("@ethersproject/hash");

var _hdnode = require("@ethersproject/hdnode");

var _keccak = require("@ethersproject/keccak256");

var _properties = require("@ethersproject/properties");

var _random = require("@ethersproject/random");

var _signingKey2 = require("@ethersproject/signing-key");

var _jsonWallets = require("@ethersproject/json-wallets");

var _transactions = require("@ethersproject/transactions");

var _logger = require("@ethersproject/logger");

var _version = require("./_version");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var logger = new _logger.Logger(_version.version);

function isAccount(value) {
  return value != null && (0, _bytes.isHexString)(value.privateKey, 32) && value.address != null;
}

function hasMnemonic(value) {
  var mnemonic = value.mnemonic;
  return mnemonic && mnemonic.phrase;
}

var Wallet = /*#__PURE__*/function (_Signer) {
  _inherits(Wallet, _Signer);

  var _super = _createSuper(Wallet);

  function Wallet(privateKey, provider) {
    var _this;

    _classCallCheck(this, Wallet);

    logger.checkNew(this instanceof Wallet ? this.constructor : void 0, Wallet);
    _this = _super.call(this);

    if (isAccount(privateKey)) {
      var signingKey = new _signingKey2.SigningKey(privateKey.privateKey);
      (0, _properties.defineReadOnly)(_assertThisInitialized(_this), "_signingKey", function () {
        return signingKey;
      });
      (0, _properties.defineReadOnly)(_assertThisInitialized(_this), "address", (0, _transactions.computeAddress)(_this.publicKey));

      if (_this.address !== (0, _address.getAddress)(privateKey.address)) {
        logger.throwArgumentError("privateKey/address mismatch", "privateKey", "[REDACTED]");
      }

      if (hasMnemonic(privateKey)) {
        var srcMnemonic = privateKey.mnemonic;
        (0, _properties.defineReadOnly)(_assertThisInitialized(_this), "_mnemonic", function () {
          return {
            phrase: srcMnemonic.phrase,
            path: srcMnemonic.path || _hdnode.defaultPath,
            locale: srcMnemonic.locale || "en"
          };
        });
        var mnemonic = _this.mnemonic;

        var node = _hdnode.HDNode.fromMnemonic(mnemonic.phrase, null, mnemonic.locale).derivePath(mnemonic.path);

        if ((0, _transactions.computeAddress)(node.privateKey) !== _this.address) {
          logger.throwArgumentError("mnemonic/address mismatch", "privateKey", "[REDACTED]");
        }
      } else {
        (0, _properties.defineReadOnly)(_assertThisInitialized(_this), "_mnemonic", function () {
          return null;
        });
      }
    } else {
      if (_signingKey2.SigningKey.isSigningKey(privateKey)) {
        /* istanbul ignore if */
        if (privateKey.curve !== "secp256k1") {
          logger.throwArgumentError("unsupported curve; must be secp256k1", "privateKey", "[REDACTED]");
        }

        (0, _properties.defineReadOnly)(_assertThisInitialized(_this), "_signingKey", function () {
          return privateKey;
        });
      } else {
        // A lot of common tools do not prefix private keys with a 0x (see: #1166)
        if (typeof privateKey === "string") {
          if (privateKey.match(/^[0-9a-f]*$/i) && privateKey.length === 64) {
            privateKey = "0x" + privateKey;
          }
        }

        var _signingKey = new _signingKey2.SigningKey(privateKey);

        (0, _properties.defineReadOnly)(_assertThisInitialized(_this), "_signingKey", function () {
          return _signingKey;
        });
      }

      (0, _properties.defineReadOnly)(_assertThisInitialized(_this), "_mnemonic", function () {
        return null;
      });
      (0, _properties.defineReadOnly)(_assertThisInitialized(_this), "address", (0, _transactions.computeAddress)(_this.publicKey));
    }
    /* istanbul ignore if */


    if (provider && !_abstractProvider.Provider.isProvider(provider)) {
      logger.throwArgumentError("invalid provider", "provider", provider);
    }

    (0, _properties.defineReadOnly)(_assertThisInitialized(_this), "provider", provider || null);
    return _this;
  }

  _createClass(Wallet, [{
    key: "mnemonic",
    get: function get() {
      return this._mnemonic();
    }
  }, {
    key: "privateKey",
    get: function get() {
      return this._signingKey().privateKey;
    }
  }, {
    key: "publicKey",
    get: function get() {
      return this._signingKey().publicKey;
    }
  }, {
    key: "getAddress",
    value: function getAddress() {
      return Promise.resolve(this.address);
    }
  }, {
    key: "connect",
    value: function connect(provider) {
      return new Wallet(this, provider);
    }
  }, {
    key: "signTransaction",
    value: function signTransaction(transaction) {
      var _this2 = this;

      return (0, _properties.resolveProperties)(transaction).then(function (tx) {
        if (tx.from != null) {
          if ((0, _address.getAddress)(tx.from) !== _this2.address) {
            logger.throwArgumentError("transaction from address mismatch", "transaction.from", transaction.from);
          }

          delete tx.from;
        }

        var signature = _this2._signingKey().signDigest((0, _keccak.keccak256)((0, _transactions.serialize)(tx)));

        return (0, _transactions.serialize)(tx, signature);
      });
    }
  }, {
    key: "signMessage",
    value: function signMessage(message) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee() {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", (0, _bytes.joinSignature)(this._signingKey().signDigest((0, _hash.hashMessage)(message))));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "_signTypedData",
    value: function _signTypedData(domain, types, value) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var _this3 = this;

        var populated;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _hash._TypedDataEncoder.resolveNames(domain, types, value, function (name) {
                  if (_this3.provider == null) {
                    logger.throwError("cannot resolve ENS names without a provider", _logger.Logger.errors.UNSUPPORTED_OPERATION, {
                      operation: "resolveName",
                      value: name
                    });
                  }

                  return _this3.provider.resolveName(name);
                });

              case 2:
                populated = _context2.sent;
                return _context2.abrupt("return", (0, _bytes.joinSignature)(this._signingKey().signDigest(_hash._TypedDataEncoder.hash(populated.domain, types, populated.value))));

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "encrypt",
    value: function encrypt(password, options, progressCallback) {
      if (typeof options === "function" && !progressCallback) {
        progressCallback = options;
        options = {};
      }

      if (progressCallback && typeof progressCallback !== "function") {
        throw new Error("invalid callback");
      }

      if (!options) {
        options = {};
      }

      return (0, _jsonWallets.encryptKeystore)(this, password, options, progressCallback);
    }
    /**
     *  Static methods to create Wallet instances.
     */

  }], [{
    key: "createRandom",
    value: function createRandom(options) {
      var entropy = (0, _random.randomBytes)(16);

      if (!options) {
        options = {};
      }

      if (options.extraEntropy) {
        entropy = (0, _bytes.arrayify)((0, _bytes.hexDataSlice)((0, _keccak.keccak256)((0, _bytes.concat)([entropy, options.extraEntropy])), 0, 16));
      }

      var mnemonic = (0, _hdnode.entropyToMnemonic)(entropy, options.locale);
      return Wallet.fromMnemonic(mnemonic, options.path, options.locale);
    }
  }, {
    key: "fromEncryptedJson",
    value: function fromEncryptedJson(json, password, progressCallback) {
      return (0, _jsonWallets.decryptJsonWallet)(json, password, progressCallback).then(function (account) {
        return new Wallet(account);
      });
    }
  }, {
    key: "fromEncryptedJsonSync",
    value: function fromEncryptedJsonSync(json, password) {
      return new Wallet((0, _jsonWallets.decryptJsonWalletSync)(json, password));
    }
  }, {
    key: "fromMnemonic",
    value: function fromMnemonic(mnemonic, path, wordlist) {
      if (!path) {
        path = _hdnode.defaultPath;
      }

      return new Wallet(_hdnode.HDNode.fromMnemonic(mnemonic, null, wordlist).derivePath(path));
    }
  }]);

  return Wallet;
}(_abstractSigner.Signer);

exports.Wallet = Wallet;

function verifyMessage(message, signature) {
  return (0, _transactions.recoverAddress)((0, _hash.hashMessage)(message), signature);
}

function verifyTypedData(domain, types, value, signature) {
  return (0, _transactions.recoverAddress)(_hash._TypedDataEncoder.hash(domain, types, value), signature);
}